import { Button } from "@/components/ui/button";
import useSegmentStore from "@/store/share-of-voice/segment/segment.slice";
import { PlusIcon } from "@phosphor-icons/react";

/**
 * Custom no rows overlay component with better styling and messaging
 */
const NoRowsOverlay = () => {
  const setIsCreateOrEditSegmentModalOpen = useSegmentStore(
    (state) => state.setIsCreateOrEditSegmentModalOpen,
  );

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCreateOrEditSegmentModalOpen(true);
  };

  return (
    <div
      className="flex flex-col items-center justify-center h-full py-8 px-4"
      style={{ pointerEvents: "auto" }}
      aria-live="polite"
    >
      <Button
        variant="ghost"
        className="gap-2 text-xs"
        onClick={handleClick}
        size={"sm"}
        aria-label="Add a segment to get started"
      >
        <PlusIcon className="h-3 w-3 text-gray-600" />
        Add a segment to get started
      </Button>
    </div>
  );
};

export default NoRowsOverlay;
